/**
 * 随机生成字符串
 * @param len 指定生成字符串长度
 */
function getRandomString(len){
    // let min = 0, max = _charStr.length-1, _str = '';
    let min = 0, max = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length-1, _str = '';
    //判断是否指定长度，否则默认长度为15
    len = len || 15;
    //循环生成字符串
    for(var i = 0, index; i < len; i++){
        index = RandomIndex(min, max, i);
        // _str += _charStr[index];
        _str += "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789"[index];
    }
    return _str;
}
/**
 * 获取浏览器信息
 * @returns {object}
 */
function getBrowser() {
    let operatingSystem = '';
    let agent = navigator.userAgent.toLowerCase();
    if (/macintosh|mac os x/i.test(agent)) {
        operatingSystem = 'mac';
    } else if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
        operatingSystem = '32';
    } else if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
        operatingSystem = '64';
    }
    return {
        navigator: navigator,
        appVersion: navigator.appVersion,
        userAgent: navigator.userAgent,
        language: (navigator.browserLanguage || navigator.language).toLowerCase(),
        versions: (function () {
            let u = navigator.userAgent;
            return {
                trident: u.includes('Trident'), //IE内核
                presto: u.includes('Presto'), //opera内核
                webKit: u.includes('AppleWebKit'), //苹果、谷歌内核
                gecko: u.includes('Gecko') && !u.includes('KHTML'), //火狐内核
                ie: window.ActiveXObject || 'ActiveXObject' in window, //是否为IE
                edge: u.includes('Edge'), //是否为Edge
                opera: u.includes('Opera'), //是否为Opera
                firefox: u.includes('Firefox'), //是否为Firefox
                safari: u.includes('Safari') && !u.includes('Chrome'), //是否为Safari
                chrome:
                    u.includes('Chrome') && u.includes('Safari') && !u.includes('Edge'), //是否为Chrome
                win: u.includes('Win'), //是否为Windows
                mac: u.includes('Mac'), //是否为Mac
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否为ios终端
                android: u.includes('Android') || u.includes('Adr'), //是否为android终端
                iPhone: u.includes('iPhone'), //是否为iPhone或者QQHD浏览器
                iPad: u.includes('iPad'), //是否为iPad
                webApp: !u.includes('Safari'), //是否为web应用程序，没有头部与底部
                weChat: u.includes('MicroMessenger'), //是否为微信
                alipay: u.includes('AlipayClient'), //是否为支付宝
                weibo: u.includes('Weibo'), //是否为微博
                dingTalk: u.includes('DingTalk'), //是否为钉钉
                qq: !!u.match(/QQ\//i), //是否为QQ
                operatingSystem: operatingSystem, // 电脑操作系统 32/64/mac
            };
        })(),
    };
}
function download(url, fileName = '') {
    let isChrome = getBrowser().versions.chrome;
    if (isChrome) {
        let element = document.createElement('a');
        element.href = url;
        element.download = fileName;
        element.style.display = 'none';
        element.click();
    } else {
        window.open(url);
    }
}
/**
 * 生成UUID
 * @returns {string}
 */
function generateShortId(toString = false) {
    let shortId = parseInt(Math.random() * 1e10);
    if (toString) {
        shortId = String(shortId);
    }
    return shortId;
}
function getAppVersion(){
    return process.env.VUE_APP_API_VERSION;
}
/**
 * 随机生成索引
 * @param min 最小值
 * @param max 最大值
 * @param i 当前获取位置
 */
function RandomIndex(min, max, i){
    let index = Math.floor(Math.random()*(max-min+1)+min),

        // numStart = _charStr.length - 10;
        numStart = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length - 10;
    //如果字符串第一位是数字，则递归重新获取
    if(i==0&&index>=numStart){
        index = RandomIndex(min, max, i);
    }
    //返回最终索引值
    return index;
}
/**
 * 判断是否为空
 * @param value
 * @returns {boolean}
 */
function isEmpty(value) {
    if (typeof value === 'undefined') {
        return true;
    } else if (value === null) {
        return true;
    } else if (typeof value === 'string' && value === '') {
        return true;
    } else if (typeof value === 'number' && isNaN(value)) {
        return true;
    } else if (Array.isArray(value) && value.length === 0) {
        return true;
    } else if (value instanceof Number && isNaN(value)) {
        return true;
    } else if (
        value.toString() === '[object Object]' &&
        Object.keys(value).length === 0
    ) {
        return true;
    } else {
        return false;
    }
}
/**
 * 判断是否为不空
 * @param value
 * @returns {boolean}
 */
function isNotEmpty(value){
    return !isEmpty(value);
}
function getFileStr(file){
    return new Promise((resolve, reject)=>{
        let reader = new FileReader();

        // 文件读取成功完成后的处理
        reader.onload = function(e) {
            // var contents = e.target.result;
            // console.log(contents); // 这里是图片的字符串形式
            // 接下来你可以将字符串发送到服务器或者进行其他操作
            return resolve(e.target.result)
        };
        // 以DataURL的形式读取文件内容
        reader.readAsDataURL(file);
    })
}
/**
 * 获取日期时间信息
 * @param value
 * @returns {object}
 */
function getDateInfo(value) {
    let date, year, month, week, day, hours, minutes, seconds, time;
    if (typeof value === 'string') {
        value = value.replace(/-/g, '/');
    }
    date = !isEmpty(value) ? new Date(value) : new Date();
    year = date.getFullYear();
    month = date.getMonth() + 1;
    month = month > 9 ? month : `0${month}`;
    week = date.getDay();
    day = date.getDate();
    day = day > 9 ? day : `0${day}`;
    hours = date.getHours();
    hours = hours > 9 ? hours : `0${hours}`;
    minutes = date.getMinutes();
    minutes = minutes > 9 ? minutes : `0${minutes}`;
    seconds = date.getSeconds();
    seconds = seconds > 9 ? seconds : `0${seconds}`;
    time = date.getTime();
    return (function () {
        return {
            date: date,
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            week: week,
            day: date.getDate(),
            hours: date.getHours(),
            minutes: date.getMinutes(),
            seconds: date.getSeconds(),
            dateInfo: `${year}-${month}-${day}`,
            timeInfo: `${hours}:${minutes}:${seconds}`,
            dateTimeInfo: `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
            time: time,
        };
    })();
}
function getQuery(params){
    let query = '?'
    Object.keys(params).forEach(key=>{
        if(!isEmpty(params[key])){
            if(query == '?'){
                query+=(key+'='+params[key]);
            }else{
                query+=('&'+key+'='+params[key]);
            }
        }
    });
    return query
}

function getQuery2(params){
    let query = '';
    if(isEmpty(params)){
        return query;
    }
    Object.keys(params).forEach(key=>{
        if(!isEmpty(params[key])){
            if(query == ''){
                query+=(key+'='+params[key]);
            }else{
                query+=('&'+key+'='+params[key]);
            }
        }
    });
    return query
}

let FUN = {
    /**
     * 添加事件绑定
     * @param element
     * @param event
     * @param handler
     */
    addEvent: (function () {
        if (document.addEventListener) {
            return (element, event, handler, useCapture = false) => {
                element.addEventListener(event, handler, useCapture);
            };
        } else if (document.attachEvent) {
            return (element, event, handler) => {
                element.attachEvent('on' + event, handler);
            };
        } else {
            return (element, event, handler) => {
                element['on' + event] = handler;
            };
        }
    })(),

    /**
     * 移除事件绑定
     * @param element
     * @param event
     * @param handler
     */
    removeEvent: (function () {
        if (document.removeEventListener) {
            return (element, event, handler, useCapture = false) => {
                element.removeEventListener(event, handler, useCapture);
            };
        } else if (document.detachEvent) {
            return (element, event, handler) => {
                element.detachEvent('on' + event, handler);
            };
        } else {
            return (element, event, handler) => {
                element['on' + event] = null;
            };
        }
    })(),
}
const addEvent = FUN.addEvent;
const removeEvent = FUN.removeEvent
export {
    addEvent,
    download,
    removeEvent,
    getRandomString,
    generateShortId,
    isNotEmpty,
    isEmpty,
    getDateInfo,
    getQuery,
    getQuery2,
    getAppVersion,
    RandomIndex,
    getFileStr
}
